import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ImageWithBasePath from '../../../../core/img/ImageWithBasePath';
import PagesAuthHeader from './common/header';
import { all_routes } from '../../../../core/data/routes/all_routes';
import AuthFooter from './common/footer';
import { InputOtp } from 'primereact/inputotp';
import { useLocation } from 'react-router-dom';

const PhoneOtp = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [token, setTokens] = useState<string>('');
  const [timer, setTimer] = useState<number>(60); // OTP Timer
  const location = useLocation();
  const { phoneNumber, confirmationResult } = location.state || {};

  useEffect(() => {
    // Timer countdown for OTP expiry
    if (timer === 0) return;
    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval); // Clear interval on component unmount
  }, [timer]);

  const handleOtpSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); // Prevent form submission

    if (!confirmationResult) {
      alert("Please provide a valid phone number and OTP request.");
      return;
    }

    try {
      const result = await confirmationResult.confirm(token);
      console.log("User authenticated successfully:", result.user);
      alert("Authentication successful!");
      navigate(routes.successPage); // Navigate to the success page after successful authentication
    } catch (error) {
      console.error("OTP verification failed:", error);
      alert("Incorrect OTP. Please try again.");
    }
  };

  const handleResendOtp = () => {
    // Resend OTP logic
    if (!confirmationResult) {
      alert("Unable to resend OTP. Please try again.");
      return;
    }
    // Trigger resend OTP here if necessary (confirming confirmationResult again)
    alert("OTP Resent. Please check your phone.");
    setTimer(60); // Reset the timer for the new OTP
  };

  return (
    <>
      <PagesAuthHeader />
      <div className="main-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5 mx-auto">
              <form onSubmit={handleOtpSubmit} className="digit-group">
                <div className="d-flex flex-column justify-content-center">
                  <div className="card p-sm-4">
                    <div className="card-body">
                      <div className="text-center mb-3">
                        <h3 className="mb-2">Phone OTP Test Verification</h3>
                        <p>OTP sent to your mobile number ending&nbsp;******{phoneNumber?.slice(-4)}</p>
                      </div>
                      <div className="text-center otp-input">
                        <div className="d-flex align-items-center justify-content-center mb-3">
                          <InputOtp
                            value={token}
                            onChange={(e) => setTokens(e.value)}
                            integerOnly
                            autoFocus
                          />
                        </div>
                        <div>
                          <div className="badge bg-danger-transparent mb-3">
                            <p className="d-flex align-items-center">
                              <i className="ti ti-clock me-1" />
                              {timer.toString().padStart(2, '0')}:00
                            </p>
                          </div>
                          <div className="mb-3 d-flex justify-content-center">
                            <p>
                              Didn’t get the OTP?{" "}
                              <Link to="#" className="text-primary" onClick={handleResendOtp}>
                                Resend OTP
                              </Link>
                            </p>
                          </div>
                          <div>
                            <button className="btn btn-lg btn-linear-primary w-100" type="submit">
                              Verify & Proceed
                            </button>
                          </div>
                        </div>
                      </div>
                      <div>
                        <ImageWithBasePath
                          src="assets/img/bg/authentication-bg.png"
                          className="bg-left-top"
                          alt="Img"
                        />
                        <ImageWithBasePath
                          src="assets/img/bg/authentication-bg.png"
                          className="bg-right-bottom"
                          alt="Img"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <AuthFooter />
    </>
  );
};

export default PhoneOtp;
